<template>
  <div class="departedDetail">
    <div class="list-container" v-for="(item, index) in tableData" :key="index">
      <div class="left">
        <div class="list-item">
          {{ $t.onlineOrder.postNumber }}：{{ item.ExpressNumber }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.cargoTrackingNumber }}：{{ item.CargoTrackingNumber }}
        </div>
        <div class="list-item">{{ $t.onlineOrder.goodsName }}：{{ item.CargoName }}</div>
        <div class="list-item">
          {{ $t.onlineOrder.cargoQuantity }}：{{ item.CargoQuantity }}
          {{ item.QuantityUnit }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.goodsValue }}：{{ item.GoodsValue }} {{ item.Currency }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.countryName }}：{{ item.CountryName }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.cargoCategorySn }}：{{ item.CargoCategory }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.numberPackages }}：{{ item.NumberPackages }}
        </div>
        <div class="list-item">{{ $t.onlineOrder.volume }}：{{ item.Volume }}</div>
        <div class="list-item">{{ $t.onlineOrder.weight }}：{{ item.Weight }}</div>
        <div class="list-item">
          {{ $t.onlineOrder.numberBoxesOrder }}：{{ item.BoxesNumber }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.chargeableWeight }}：{{ item.ChargeableWeight }}
        </div>
        <div class="list-item">{{ $t.onlineOrder.orderDate }}：{{ item.CreateTime }}</div>
        <div class="list-item">
          {{ $t.onlineOrder.storageTime }}：{{ item.StorageTime }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.consigneeName }}：{{ item.ReceivingName }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.phoneNumber }}：{{ item.PhoneNumber }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.receivingAddress }}：{{ item.ReceivingAddress }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.isUnpack }}：<van-icon name="success" v-if="item.IsUnpack" />
        </div>
      </div>
      <div class="right">
        <div class="images">
          <van-image
            width="88"
            height="88"
            fit="cover"
            @click="imagePreview(item.ProductPictureList)"
            :src="imgUrlFilter(item.ProductPictureList[0])"
            v-if="item.ProductPictureList && item.ProductPictureList.length > 0"
          />
          <span v-else>{{ $t.onlineOrder.noImage }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Icon, Image } from "vant";

Vue.use(Button).use(Icon).use(Image);

export default {
  name: "departedDetail",
  data() {
    return {
      WB_Id: "",
      tableData: [],
    };
  },
  created() {
    const { WB_Id } = this.$route.query;
    this.WB_Id = WB_Id;
    this.getCustomerOrderListByWBId();
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      var pictureList = [];
      for (var image of images) {
        pictureList.push(this.imgUrlFilter(image));
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: pictureList,
        startPosition: 0,
      });
    },
    getCustomerOrderListByWBId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WB_Id: this.WB_Id,
        };
        this.$api.onlineOrderManagement
          .getCustomerOrderListByWBId(param)
          .then((res) => {
            this.tableData = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.departedDetail {
  width: 100%;
  display: inline-block;
  .list-container {
    font-size: 12px;
    color: #333;
    padding: 10px;
    margin-top: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
    .left {
      vertical-align: middle;
      display: inline-block;
      width: 60%;
      .list-item {
        margin-bottom: 10px;
        .van-icon-success {
          color: #01aaa3;
          font-size: 14px;
        }
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
    .right {
      vertical-align: middle;
      display: inline-block;
      width: 40%;
      .images {
        overflow: hidden;
        vertical-align: middle;
        text-align: center;
        ::v-deep img {
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
